import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List } from 'immutable';
import { useTranslation } from 'src/i18n';
import CircuitDynamicTable from '../CommissioningCircuit/CircuitDynamicTable';

// Section 7: engineering deliverable summary. The notes for it live in the sign-off panel.
export default function HmsAuditDeliverables (props) {
  const { data, onChange, readOnly } = props;
  const { t } = useTranslation();
  const deliverables = data?.get('deliverables');

  const columns = useMemo(() => [
    { key: 'deliverableType', label: t('hmsAudit.deliverables.type') },
    { key: 'countProduced', label: t('hmsAudit.deliverables.countProduced'), type: 'number', unit: 'EA' },
  ], [t]);

  // No "deliverables created?" toggle — the rows themselves answer it.
  return (
    <CircuitDynamicTable
      title={t('hmsAudit.deliverableSummary')}
      columns={columns}
      data={deliverables?.get('items') as List<any>}
      extrasKey={['deliverables', 'items']}
      onChange={onChange}
      readOnly={readOnly}
      deletable
      minRows={1}
    />
  );
}

HmsAuditDeliverables.propTypes = {
  data: ImmutablePropTypes.map,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

HmsAuditDeliverables.defaultProps = {
  readOnly: false,
};
